import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import Verzetten from '@/components/Verzetten'
import Shop from '@/components/Shop'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/verzetten',
      name: 'Verzetten',
      component: Verzetten
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js